import { getBaseUrl } from './ServiceUtils';
import appRequest from './appRequest';

const MONITORS_URL = getBaseUrl('/monitors/');

export async function getMonitors(page, size, onlyActive, standalone) {
    const params = new URLSearchParams({ page: page || 1 });
    if (size) params.set('size', size);
    if (onlyActive) params.set('onlyActive', 'true');
    if (standalone) params.set('standalone', 'true');
    return await appRequest.doGetRequest(`${MONITORS_URL}?${params}`);
}

export async function getMonitorsBySymbol(symbol) {
    return await appRequest.doGetRequest(`${MONITORS_URL}?symbol=${symbol}`);
}

export async function saveMonitor(id, newMonitor) {
    if (id)
        return await appRequest.doPatchRequest(`${MONITORS_URL}${id}`, newMonitor);
    else
        return await appRequest.doPostRequest(MONITORS_URL, newMonitor);
}

export async function startMonitor(id) {
    return await appRequest.doPostRequest(`${MONITORS_URL}${id}/start`, {});
}

export async function stopMonitor(id) {
    return await appRequest.doPostRequest(`${MONITORS_URL}${id}/stop`, {});
}

export async function deleteMonitor(id) {
    return await appRequest.doDeleteRequest(`${MONITORS_URL}${id}`);
}

export async function startAllMonitors(mode = 'all') {
    return await appRequest.doPostRequest(`${MONITORS_URL}startAll?mode=${mode}`, {});
}

export async function createMissingMonitors(symbol = 'BTCUSDT', quote = 'USDT') {
    return await appRequest.doPostRequest(`${MONITORS_URL}createMissing`, { symbol, quote });
}